// Запрос к бэку на получение списка ролей
import {
    API_LIST_OF_ROLES
} from "../constants"

export const constantsUserRoles = {
    data() {
        return {
            rolesList: [],
        }
    },
    mounted() {
        this.getRolesList()
    },
    methods: {
        getRolesList: async function() {
            const response = await api.call('get', API_LIST_OF_ROLES)
            this.rolesList = response.data
        },
    }
}

export const typeOfCompany = {
    data() {
        return {
            typeList: [
                { text: 'Выберите тип компании', value: null, disabled: true },
                { text: 'Юридическое лицо', value: 'LEGAL' },
                { text: 'Индивидуальный предприниматель', value: 'INDIVIDUAL' },
            ],
        }
    },
}

export const salesStatusListOfCompany = {
    data() {
        return {
            salesStatusList: [
                { text: 'Готов сейчас', value: 'Готов сейчас' },
                { text: 'Готов но позже', value: 'Готов но позже' },
                { text: 'Не готов', value: 'Не готов' },
            ],
        }
    },
}

export const constantsAllReferenceProperties = {
    data() {
        return {
            referencePropertiesList: [],
        }
    },
    mounted() {
        this.getReferencePropertiesList()
    },
    methods: {
        getReferencePropertiesList: async function() {
            const response = await this.$store.dispatch('GET_REFERENCE_PROPERTIES')
            this.referencePropertiesList = this.$store.getters.REFERENCE_PROPERTIES
        },
        nameByPropId(property_id) {
            if (this.referencePropertiesList[property_id] && this.referencePropertiesList[property_id].text) {
                return this.referencePropertiesList[property_id].text;
            }
            return undefined;
        },
        takeTypeOfAuto(transports) {
            return transports.map(item => (item.type_of_auto_id == 879) ? 'LTL' : 'FTL').join(', ');
        },
        takeTypeOfContainer(containers) {
            return containers.map(item => this.nameByPropId(item.type_of_container_id)).join(', ');
        }
    }
}

export const constantsAllLogisticsProperties = {
    data() {
        return {
            logisticsPropertiesList: [],
            logisticsDataNames: {
                "0.value": "Номер договора",
                "1.value": "Дата договора",
                "name_of_cargo": "Наименование груза, код ТНВЭД",
                "import_export": "Импорт / Экспорт",
                "usloviya_postavki_id": "Условия поставки",
                "naselenniy_punkt": "Населенный пункт",
                "number_of_places": "Кол-во мест",
                "weight": "Вес, кг.",
                "volume": "Объем, м3",
                "platniy_weight": "Платный вес, кг.",
                "cargo_sender_name": "Грузоотправитель",
                "address_g_o": "Адрес ГО",
                "contact_name_on_shipment": "Контактное лицо на погрузке, телефон",
                "cargo_recipient_name": "Грузополучатель",
                "cargo_recipient_partner_ids": "Партнеры-грузополучатели",
                "inn_g_p": "ИНН/КПП",
                "kpp_g_p": "КПП",
                "address_g_p": "Адрес ГП",
                "address_of_unloading": "Адрес разгрузки",
                "contact_name_on_unloading": "Контактное лицо на разгрузке, телефон",
                "tamogenniy_post_svh_id": "Название СВХ",
                "aeroport_of_otpravleniya": "Аэропорт отправления",
                "aeroport_of_naznacheniya": "Аэропорт назначения",
                "tranzitniy_aeroport": "Транзитный аэропорт",
                "nomer_of_awb": "№ AWB",
                "nomer_reisa": "Номер рейса",
                "data_vypuska_awb": "Дата выпуска AWB",
                "nazvanie_perevozchika": "Название перевозчика",
                "gotovnost_gruza_plan": "Готовность груза (план)",
                "gotovnost_gruza_fact": "Готовность груза (факт)",
                "pogruzka_plan": "Погрузка (план)",
                "pogruzka_fact": "Погрузка (факт)",
                "vilet_plan": "Вылет (план)",
                "vilet_fact": "Вылет (факт)",
                "prilet_plan": "Прилет (план)",
                "prilet_fact": "Прилет (факт)",
                "transitnoe_vremya": "Транзитное время",
                "zakritie_dostavki_plan": "Закрытие доставки (план)",
                "zakritie_dostavki_fact": "Закрытие доставки (факт)",
                "podacha_dt_plan": "Подача ДТ (план)",
                "podacha_dt_fact": "Подача ДТ (факт)",
                "vypusk_dt_plan": "Выпуск ДТ (план)",
                "vypusk_dt_fact": "Выпуск ДТ (факт)",
                "time_of_to": "Время ТО",
                "dostavka_plan": "Дата выгрузки (план)",
                "dostavka_fact": "Дата выгрузки (факт)",
                "obshee_transitnoe_vremya": "Общее транзитное время",
                "notify_contacts": "Контакты для уведомления",
                "agent_contacts": "Контакты агента",
                "perevozchik_id": "Перевозчик",
                "perevozchik_name": "Перевозчик. Наименование",
                "perevozchik_inn": "Перевозчик. ИНН",
                "perevozchik_uridicheskiy_address": "Перевозчик. Юр. адрес",
                "port_of_shipment": "Порт погрузки",
                "port_of_unloading": "Порт разгрузки",
                "station_of_incoming_id": "Станция назначения",
                "number_of_container": "Кол-во контейнеров",
                "containers": "Контейнер",
                "type_of_container_id": "Тип контейнера",
                "shipping_line": "Судоходная линия",
                "nomer_of_container": "№ контейнера",
                "name_of_ship": "Название судна",
                "country_of_ship_registration_id": "Страна регистрации судна",
                "konosaments": "Коносамент",
                "number_of_konosament": "Номер коносамента",
                "date_of_konosament_exit": "Дата выпуска коносамента",
                "sales_name": "Продавец",
                "zatarka_containera_plan": "Затарка контейнера (план)",
                "zatarka_containera_fact": "Затарка контейнера (факт)",
                "vihod_sudna_iz_porta_plan": "Выход судна из порта (план)",
                "vihod_sudna_iz_porta_fact": "Выход судна из порта (факт)",
                "pribitie_sudna_v_port_plan": "Прибытие судна в порт (план)",
                "pribitie_sudna_v_port_fact": "Прибытие судна в порт (факт)",
                "poluchenie_konosamenta_fact": "Получение коносамента (факт)",
                "vyhod_po_gd_plan": "Выход по ЖД (план)",
                "vyhod_po_gd_fact": "Выход по ЖД (факт)",
                "pribitie_na_stanciyu_plan": "Прибытие на станцию (план)",
                "pribitie_na_stanciyu_fact": "Прибытие на станцию (факт)",
                "raskreditaciya_plan": "Раскредитация (план)",
                "raskreditaciya_fact": "Раскредитация (факт)",
                "transitnoe_vremya_gd": "Транзитное время (ГД)",
                "mesto_pogruzki_strana": "Место погрузки. Страна",
                "mesto_pogruzki_gorod": "Прием груза. Город",
                "cargo_recipient_company_id": "Грузополучатель",
                "address_of_unloading_town": "Сдача груза. Город",
                "address_of_unloading_street": "Сдача груза. Улица",
                "svh_id": "СВХ станция прибытия",
                "svh_full_address": "Адрес доставки для ТО",
                "pogran_perehod_id": "Погран переход",
                "number_of_auto": "Кол-во авто",
                "transports": "Транспорт",
                "nomer_of_tyagach": "№ Тягача",
                "nomer_of_pricep": "№ Прицепа",
                "type_of_auto_id": "Тип авто",
                "volume_of_auto": "Вместимость авто, м3",
                "temp_of_auto_min": "Диапазон температур, °C",
                "temp_of_auto_max": "Диапазон температур, °C",
                "cmrs": "CMR",
                "nomer_of_cmr": "№ CMR",
                "data_pogruzki_cmr": "Дата погрузки CMR",
                "pogruzka_gruza_plan": "Дата погрузки (план)",
                "pogruzka_gruza_fact": "Дата погрузки (факт)",
                "pribitie_na_pp_plan": "Прибытие на ПП (план)",
                "pribitie_na_pp_fact": "Прибытие на ПП (факт)",
                "vyhod_s_pp_plan": "Выход с ПП (план)",
                "vyhod_s_pp_fact": "Выход с ПП (факт)",
                "pribitie_na_svh_plan": "Прибытие на СВХ (план)",
                "pribitie_na_svh_fact": "Прибытие на СВХ (факт)",
                "station_of_otpravleniya": "Станция отправления",
                "pogranichnie_stancii_perehodov": "Пограничные станции переходов",
                "nomer_smgs": "Номер СМГС",
                "data_vypuska_smgs": "Дата выпуска СМГС",
                "vihod_poezda_so_stancii_otpravleniya_plan": "Выход поезда со станции отправления (план)",
                "vihod_poezda_so_stancii_otpravleniya_fact": "Выход поезда со станции отправления (факт)",
                "pribitie_poezda_na_pp_plan": "Прибытие поезда на ПП (план)",
                "pribitie_poezda_na_pp_fact": "Прибытие поезда на ПП (факт)",
                "vyhod_poezda_s_pp_plan": "Выход поезда с ПП (план)",
                "vyhod_poezda_s_pp_fact": "Выход поезда с ПП (факт)",
                "pribitie_poezda_na_stanciyu_nazanacheniya_plan": "Прибытие поезда на станцию назначения (план)",
                "pribitie_poezda_na_stanciyu_nazanacheniya_fact": "Прибытие поезда на станцию назначения (факт)",
                "mesto_pogruzki_oblast": "Прием груза. Область",
                "mesto_pogruzki_street": "Прием груза. Улица",
                "address_of_unloading_oblast": "Сдача груза. Область",
                "marka_of_tyagach": "Марка тягача",
                "marka_of_pricep": "Марка прицепа",
                "voditel_fio": "Водитель. ФИО",
                "voditel_passport": "Водитель. Паспорт",
                "voditel_vu": "Водитель. ВУ",
                "user_comment": "Комментарий",
            }
        }
    },
    mounted() {
        this.getReferencePropertiesList()
    },
    methods: {
        getReferencePropertiesList() {
            this.logisticsPropertiesList = [];
        }
    }
}

export const typeOfTCLoadingList = {
    data() {
        return {
            typeOfTCLoadingList: [
                { text: 'Выберите тип ТС', value: null, disabled: true },
                { text: 'Верх', value: 'Верх' },
                { text: 'Бок', value: 'Бок' },
                { text: 'Зад', value: 'Зад' },
                { text: 'Верх, Бок', value: 'Верх, Бок' },
                { text: 'Верх, Зад', value: 'Верх, Зад' },
                { text: 'Бок, Зад', value: 'Бок, Зад' },
                { text: 'Любой', value: 'Любой' }
            ],
        }
    },
}

export const typeOfTransportCompanyList = {
    data() {
        return {
            typeOfTransportCompanyList: [
                { text: 'Выберите тип компании', value: null, disabled: true },
                { text: 'Агент', value: 'Агент' },
                { text: 'Собственник', value: 'Собственник' },
                { text: 'Перевозчик', value: 'Перевозчик' },
                { text: 'Экспедитор', value: 'Экспедитор' },
            ],
        }
    },
}